import React, { memo } from 'react';

const RewardSmall = memo(({ size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00026 9.61542C9.46087 9.61542 11.4556 7.72406 11.4556 5.39096C11.4556 3.05786 9.46087 1.1665 7.00026 1.1665C4.53964 1.1665 2.54492 3.05786 2.54492 5.39096C2.54492 7.72406 4.53964 9.61542 7.00026 9.61542Z"
        stroke="#5A5A5A"
        strokeMiterlimit="10"
      />
      <path
        d="M6.61569 9.6094L4.9482 12.8333L3.73666 11.2214H1.75L3.49566 8.02832"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.38428 9.6094L9.05829 12.8333L10.2633 11.2214H12.25L10.5043 8.02832"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default RewardSmall;
